import { jsx as _jsx } from "react/jsx-runtime";
import { LineSmallStyle, LineStyle } from './style';
export function LineSmall() {
    return _jsx(LineSmallStyle, {});
}
export function Line() {
    return _jsx(LineStyle, {});
}
